export const MENU_STAT = 'MENU_STAT';
export const DRAWER_MENU='DRAWER_MENU';
export const ALL_PROTOCOLS="ALL_PROTOCOLS";
